"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ButtonDropdown = require("../button-dropdown/ButtonDropdown");
var _Icon = require("../svg/Icon");
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var extraLargeScreen = 1440;
var largeScreen = 1360;
var mediumScreen = 1024;
var smallScreen = 768;
var extraScreen = 600;
var isIE = '';
var Breadcrumb = /*#__PURE__*/function (_Component) {
  _inherits(Breadcrumb, _Component);
  var _super = _createSuper(Breadcrumb);
  function Breadcrumb(props) {
    var _this;
    _classCallCheck(this, Breadcrumb);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "breadcrumbRef", void 0);
    _this.state = {
      viewport: _this.getViewportSize()
    };
    _this.setViewport = _this.setViewport.bind(_assertThisInitialized(_this));
    _this.breadcrumbRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  _createClass(Breadcrumb, [{
    key: "getWidth",
    value: function getWidth() {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
  }, {
    key: "setViewport",
    value: function setViewport(event) {
      var size = this.getViewportSize();
      this.setState({
        viewport: size
      });
    }
  }, {
    key: "getViewportSize",
    value: function getViewportSize() {
      var width = this.getWidth();
      var size = 'xs';
      if (width >= extraScreen) size = 'xs';
      if (width >= smallScreen) size = 'sm';
      if (width >= mediumScreen) size = 'md';
      if (width >= largeScreen) size = 'lg';
      if (width >= extraLargeScreen) size = 'xl';
      return size;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var ua = window.navigator.userAgent;
      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        isIE = 't1-dropdown-magin';
      }
      if (this.breadcrumbRef && this.breadcrumbRef.current) {
        var element = this.breadcrumbRef.current.querySelector('.tl-dropdown-icon');
        if (element) {
          element.setAttribute('aria-label', 'Show Truncated Pages');
          element.setAttribute('role', 'button');
          element.setAttribute('alttext', 'Show Truncated Pages');
        }
      }
      this.setViewport(null);
      window.addEventListener('resize', this.setViewport);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setViewport);
    }
  }, {
    key: "getSeparatorIcon",
    value: function getSeparatorIcon(key, iconName) {
      return /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
        key: key,
        name: iconName,
        className: this.state.viewport === 'xs' ? 'tl-breadcrumb-separator tl-breadcrumb-separator-mobile' : 'tl-breadcrumb-separator'
      });
    }
  }, {
    key: "getClassName",
    value: function getClassName() {
      var customClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var classNames = "tl-breadcrumb ".concat(customClass || '');
      return classNames;
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      return this.state.viewport === 'xs';
    }
  }, {
    key: "generateBreadcrumbItem",
    value: function generateBreadcrumbItem(props) {
      var _this2 = this;
      var id = props.id,
        className = props.className,
        active = props.active,
        disabled = props.disabled,
        icon = props.icon,
        onClick = props.onClick,
        link = props.link,
        label = props.label,
        key = props.key;
      if (active || !link && !onClick) {
        return /*#__PURE__*/_react.default.createElement("a", {
          key: key,
          id: id,
          className: "tl-breadcrumb-item tl-breadcrumb-item-anchor ".concat(className || '', " ").concat(active ? 'active' : '', " ").concat(disabled ? 'disable' : '')
        }, icon && /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
          name: icon,
          className: "tl-breadcrumb-item-icon"
        }), " ", /*#__PURE__*/_react.default.createElement("span", null, label));
      }
      if (link && onClick) {
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: link || '',
          key: key,
          id: id,
          className: "tl-breadcrumb-item tl-breadcrumb-item-anchor ".concat(className || '', " ").concat(active ? 'active' : '', " ").concat(disabled ? 'disable' : ''),
          onClick: onClick,
          onKeyDown: function onKeyDown(e) {
            return _this2.onKeyChange(e, props);
          }
        }, icon && /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
          name: icon,
          className: "tl-breadcrumb-item-icon"
        }), " ", /*#__PURE__*/_react.default.createElement("span", null, label));
      }
      if (link) {
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
          to: link || '',
          key: key,
          id: id,
          onKeyDown: function onKeyDown(e) {
            return _this2.onKeyChange(e, props);
          },
          className: "tl-breadcrumb-item tl-breadcrumb-item-anchor ".concat(className || '', " ").concat(active ? 'active' : '', " ").concat(disabled ? 'disable' : '')
        }, icon && /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
          name: icon,
          className: "tl-breadcrumb-item-icon"
        }), " ", /*#__PURE__*/_react.default.createElement("span", null, label));
      }
      if (onClick) {
        return /*#__PURE__*/_react.default.createElement("a", {
          key: key,
          id: id,
          onKeyDown: function onKeyDown(e) {
            return _this2.onKeyChange(e, props);
          },
          className: "tl-breadcrumb-item tl-breadcrumb-item-anchor ".concat(className || '', " ").concat(active ? 'active' : '', " ").concat(disabled ? 'disable' : ''),
          onClick: onClick,
          tabIndex: 0
        }, icon && /*#__PURE__*/_react.default.createElement(_Icon.SvgIcon, {
          name: icon,
          className: "tl-breadcrumb-item-icon"
        }), label);
      }
    }
  }, {
    key: "onKeyChange",
    value: function onKeyChange(event, props) {
      var onClick = props.onClick,
        link = props.link;
      if (event.keyCode === 13 || event.keyCode === 32) {
        if (link) {
          event.target.click();
        }
        return onClick && onClick(event);
      }
    }
  }, {
    key: "breadcrumbRenderer",
    value: function breadcrumbRenderer() {
      var _this3 = this;
      var linksRef = /*#__PURE__*/_react.default.createRef();
      var onOptionClicked = function onOptionClicked(event, data) {
        var currentItemData = event.target.getAttribute('data-item');
        var clickedItem = data.find(function (item) {
          return item.label === currentItemData;
        });
        if (clickedItem && clickedItem.onClick) {
          clickedItem.onClick(event);
        }
        if (clickedItem && clickedItem.link) {
          var clickableLink = linksRef.querySelector("[data-keyforclick=\"".concat(clickedItem.itemId, "\"]"));
          if (clickableLink) clickableLink.click();
        }
      };
      var _this$props = this.props,
        items = _this$props.items,
        collapse = _this$props.collapse,
        separator = _this$props.separator;
      var dropdownOptions = [];
      var itemLength = items.length;
      if (this.isMobile()) {
        var mobileIcon = this.isMobile() ? 'icon-system-ui-left-arrow' : separator ? separator : 'icon-system-right-arrow';
        var seperatorIcon = this.getSeparatorIcon('separator', mobileIcon);
        var currentItem = items.length > 1 ? items[items.length - 2] : items[0];
        return currentItem && [seperatorIcon, this.generateBreadcrumbItem(_objectSpread(_objectSpread({}, currentItem), {}, {
          key: "active-item"
        }))];
      }
      var data = [];
      items.forEach(function (item, key) {
        if (itemLength > 3 && collapse) {
          if (key === 0 || key === itemLength - 1 || key === itemLength - 2) {
            data.push(_objectSpread(_objectSpread({}, _this3.generateBreadcrumbItem(item)), {}, {
              key: key
            }));
          } else {
            dropdownOptions.push(_objectSpread(_objectSpread({}, item), {}, {
              displayText: item.label,
              itemId: item.label
            }));
          }
        } else {
          data.push(_objectSpread(_objectSpread({}, _this3.generateBreadcrumbItem(item)), {}, {
            key: key
          }));
        }
      });
      if (itemLength > 3 && collapse) {
        var dropdownComponent = /*#__PURE__*/_react.default.createElement("div", {
          tabIndex: -1,
          className: "t1-dropdown-button ".concat(isIE),
          key: "breadcrumb-dropdown-".concat(this.props.id)
        }, /*#__PURE__*/_react.default.createElement(_ButtonDropdown.ButtonDropdown, {
          dropdownId: "breadcrumb-dropdown-".concat(this.props.id, " "),
          buttonType: "type2",
          label: "icon-system-ellipsis",
          options: dropdownOptions,
          onOptionClick: function onOptionClick(id, event) {
            return onOptionClicked(event, dropdownOptions);
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "tl-no-display",
          ref: function ref(element) {
            return linksRef = element;
          }
        }, dropdownOptions.filter(function (item) {
          return item.link;
        }).map(function (item) {
          return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
            to: item.link || '',
            "data-keyforclick": item.itemId,
            key: item.itemId,
            id: item.itemId
          }, item.itemId);
        })));
        data.splice(1, 0, dropdownComponent);
      }
      return this.reducedBreadcrumb(data);
    }
  }, {
    key: "reducedBreadcrumb",
    value: function reducedBreadcrumb(data) {
      var _this4 = this;
      var separator = this.props.separator;
      return data.reduce(function (acc, current, index, arr) {
        if (index !== arr.length - 1) {
          var separatorWithIcon = _this4.getSeparatorIcon("sep-".concat(index), separator);
          acc.push(current);
          acc.push(separatorWithIcon);
        } else {
          acc.push(current);
        }
        return acc;
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        id = _this$props2.id,
        className = _this$props2.className;
      return /*#__PURE__*/_react.default.createElement("nav", {
        ref: this.breadcrumbRef,
        "aria-label": "Breadcrumbs",
        id: id,
        className: this.getClassName(className)
      }, this.breadcrumbRenderer());
    }
  }]);
  return Breadcrumb;
}(_react.Component);
exports.default = Breadcrumb;
_defineProperty(Breadcrumb, "defaultProps", {
  separator: 'icon-system-right-arrow'
});